import React from 'react'

import { registersEmployer } from '../donate_v6/useEmployerMatching'

// Bootstrap twin: donate_v6/EmployerMatchingStatus.jsx — see there for why
// this exists and when it renders.
const EmployerMatchingStatus = ({ i18n, employerMatching, shares }) => {
  if (!employerMatching?.enabled) return null

  const entered = employerMatching.employerEntered
  const enabled = registersEmployer(shares)

  return (
    <p
      role="status"
      aria-live="polite"
      className={entered ? 'text-sm text-gray-500 text-start' : 'sr-only'}
    >
      {entered && <>
        {i18n.t('employer_matching.status')}
        {' '}
        <span className={enabled ? 'text-green-700' : 'text-red-700'}>
          {i18n.t(`employer_matching.${enabled ? 'status_enabled' : 'status_disabled'}`)}
        </span>
      </>}
    </p>
  )
}

export default EmployerMatchingStatus
